import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  LabelList,
} from "recharts";

const COLORS = [
  "#6366F1", // Indigo
  "#8B5CF6", // Violet
  "#06B6D4", // Cyan
  "#10B981", // Emerald
  "#F59E0B", // Amber
  "#EF4444", // Red
  "#EC4899", // Pink
  "#3B82F6", // Blue
  "#14B8A6", // Teal
  "#84CC16", // Lime
  "#F97316", // Orange
  "#A855F7", // Purple
  "#0EA5E9", // Sky
  "#22C55E", // Green
  "#EAB308", // Yellow
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    return (
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: "10px 14px",
          boxShadow: "0 6px 20px rgba(0,0,0,.15)",
          border: "none",
        }}
      >
        <div style={{ fontWeight: 600 }}>{payload[0].payload.name}</div>
        <div style={{ color: "#6366F1", marginTop: 4 }}>
          Activities: {payload[0].value}
        </div>
      </div>
    );
  }

  return null;
};

const CustomBarChart = ({ data = [], height = 320 }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        margin={{
          top: 15,
          right: 15,
          left: 5,
          bottom: 15,
        }}
      >
        <defs>
          <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#6D5BFF" />
            <stop offset="100%" stopColor="#4F46E5" />
          </linearGradient>
        </defs>

        <XAxis
          dataKey="name"
          tickFormatter={(name) =>
            name?.length > 12 ? `${name.substring(0, 12)}...` : name
          }
          tick={{
            fontSize: 11,
            fill: "#4B5563",
          }}
          axisLine={{
            stroke: "#D1D5DB",
            strokeWidth: 1,
          }}
          tickLine={{
            stroke: "#D1D5DB",
          }}
          interval={0}
          height={35}
        />

        <YAxis
          allowDecimals={false}
          width={28}
          tick={{
            fontSize: 11,
            fill: "#4B5563",
          }}
          axisLine={{
            stroke: "#D1D5DB",
            strokeWidth: 1,
          }}
          tickLine={{
            stroke: "#D1D5DB",
          }}
        />

        <Tooltip content={<CustomTooltip />} />

        <Bar
          dataKey="count"
          fill="url(#barGradient)"
          radius={[10, 10, 0, 0]}
          maxBarSize={55}
          animationDuration={1200}
        >
          <LabelList
            dataKey="count"
            position="top"
            style={{
              fontWeight: 600,
              fill: "#374151",
              fontSize: 12,
            }}
          />

          {data.map((_, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
